import { SocialMediaApiResponse, SocialMediaParams } from '../../common/social-media.interface';

const BASE_URL = 'https://crawler.8am.vn/api/content/category/e3e1585d-7590-49b9-a52b-27a294ff0bd0';

export const socialMediaApi = {
  // Lấy danh sách bài viết từ API 8am.vn
  getSocialMediaPosts: async (params: SocialMediaParams = {}): Promise<SocialMediaApiResponse> => {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.page) queryParams.append('page', params.page.toString());
      if (params.pageSize) queryParams.append('pageSize', params.pageSize.toString());
      if (params.sortBy) queryParams.append('sortBy', params.sortBy);
      if (params.desc !== undefined) queryParams.append('desc', params.desc.toString());

      const url = `${BASE_URL}?${queryParams.toString()}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: SocialMediaApiResponse = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching social media posts:', error);
      throw error;
    }
  },

  // Lấy danh sách bài viết với phân trang
  getPaginatedPosts: async (
    page: number = 1, 
    pageSize: number = 10, 
    sortBy: string = 'postedAt', 
    desc: boolean = true
  ): Promise<SocialMediaApiResponse> => {
    return socialMediaApi.getSocialMediaPosts({
      page,
      pageSize,
      sortBy,
      desc
    });
  }
};
